const CORPORATE_MASTER_LIST_PATH = "/corporate-master";

/** 詳細画面への遷移state。一覧へ戻るときに検索条件を戻すため、一覧のURLクエリを持たせる */
export interface CorporateMasterDetailState {
  listSearch: string;
}

/**
 * 詳細画面から戻る一覧のパス。一覧から開いたときは、そのときの検索条件を付ける
 * @param state 詳細画面の遷移state（直接開いたときは null）
 * @returns 画面パス
 */
export const corporateMasterListPathFrom = (state: unknown): string => {
  const listSearch =
    typeof state === "object" && state !== null && "listSearch" in state
      ? state.listSearch
      : null;
  return typeof listSearch === "string" && listSearch.startsWith("?")
    ? `${CORPORATE_MASTER_LIST_PATH}${listSearch}`
    : CORPORATE_MASTER_LIST_PATH;
};

/**
 * 法人マスタ詳細画面のパス
 * @param corporateNumber 法人番号（13桁）
 * @returns 画面パス
 */
export const corporateMasterDetailPath = (corporateNumber: string): string =>
  `/corporate-master/${corporateNumber}`;

/**
 * 商業登記取得画面（commercialbook）への遷移先。会社法人等番号と法人名を初期入力にする
 * @param corporateNumberLast12 会社法人等番号（12桁）
 * @param name 法人名
 * @param options.reuse リユース取得で開く場合は true
 * @returns 画面パス
 */
export const buildAcquireUrl = (
  corporateNumberLast12: string,
  name: string | null,
  options: { reuse?: boolean; returnCorporateNumber?: string } = {}
): string => {
  const base = `/commercialbook?corporateNumber=${encodeURIComponent(
    corporateNumberLast12
  )}&companyName=${encodeURIComponent(name ?? "")}`;
  if (!options.reuse) return base;
  const returnQuery = options.returnCorporateNumber
    ? `&returnCorporateNumber=${encodeURIComponent(
        options.returnCorporateNumber
      )}`
    : "";
  return `${base}&reuse=1${returnQuery}`;
};
